import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchUnreadMessageCount() {
  return axiosRequest('get', serviceUrls.DASHBOARD_UNREAD_MESSAGE_SERVICE);
}

export function fetchSLAStatus() {
  return axiosRequest('get', serviceUrls.DASHBOARD_GET_SLASTATUS);
}

export function getCaseDetails(caseId) {
  return axiosRequest('get', serviceUrls.DASHBOARD_GET_CASEDETAILS, { caseId });
}

export function getCases(payload) {
  return axiosRequest('post', serviceUrls.DASHBOARD_GET_CASES, payload);
}

export function getCaseStatusInfo(caseId) {
  return axiosRequest('get', serviceUrls.DASHBOARD_GET_CASES_STATUS, { id: caseId });
}

export function getCaseFiltersAPI() {
  return axiosRequest('get', serviceUrls.CASES_GET_FILTERS);
}

export function getAppTypesByCountry(countryId) {
  return axiosRequest('get', serviceUrls.CASES_GET_APPLICANT_TYPE_BY_COUNTRY + countryId);
}

export function getUnreadMessageCount() {
  return axiosRequest('get', serviceUrls.DASHBOARD_UNREAD_MESSAGE_COUNT_SERVICE);
}
